import * as React from 'react';
import { Trans } from "react-i18next";
import { ButtonBase } from '@mui/material'
import { batch } from 'react-redux';

export type Props = {
	onTogglePreviewFabric?: Function,
	resizeViewer?: (width:number, height:number) => void
	windowWidth: number,
	viewerHeight: number,
	previewFabricEnabled: boolean
}

const T = ({children, ...otherProps}:any) => <Trans ns="create" {...otherProps}>{children}</Trans>

export default class SaveButton extends React.Component<Props> {

	render = () => <>
		<ButtonBase style={ {borderRadius: '3px'} } >
			<div onClick={() => { 
				batch(() => {
					this.props.onTogglePreviewFabric();
					this.props.resizeViewer(this.props.previewFabricEnabled ? this.props.windowWidth - 100 : this.props.windowWidth - 280, this.props.viewerHeight);
				});
			}} className="action-buttons-icon grey-bg">
				<img src="static/img/icons/preview-icon.svg" alt="" width="22" height="22" />
				<div className="text">PREVIEW</div>
			</div>
		</ButtonBase>
	</>
}